module.exports = __webpack_public_path__ + "static/media/basel-19.310b00c6.jpg";